import React from 'react';
import { topicLimitDialogViewStates, messages } from '../constants';

interface TopicLimitDialogProps {
    viewState: number;
    viewStates: typeof topicLimitDialogViewStates;
    onClose: () => void;
    message?: string;
}

export function TopicLimitDialog({ viewState, viewStates, onClose, message }: TopicLimitDialogProps) {
    const body = message ?? messages.topicLimitMessage;
    switch (viewState) {
        case viewStates.closed:
            return null;
        case viewStates.open:
            return (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
                        <div className="p-6">
                            <div className="flex items-center space-x-3 mb-4">
                                <div className="flex-shrink-0">
                                    <svg className="w-6 h-6 text-amber-500" fill="none"
                                         stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                                    </svg>
                                </div>
                                <h3 className="text-lg font-semibold text-gray-900">
                                    {messages.topicLimitTitle}
                                </h3>
                            </div>
                            <p className="text-gray-600 mb-4 ml-9">
                                {body}
                            </p>
                            <div className="flex justify-end">
                                <button
                                    onClick={onClose}
                                    className="px-4 py-2 bg-action-blue text-white rounded-lg hover:bg-action-blue-dark transition-colors"
                                >
                                    {messages.okButton}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        default:
            return null;
    }
}
